import React from 'react'
import { useLocation } from 'react-router-dom';
import { useEffect, useState, useRef } from 'react';
import { Drawer } from '@material-ui/core';
import { useDispatch, useSelector  } from "react-redux";
import { useHistory} from 'react-router-dom';
import imgquit from '../Resources/quit.png';
import StaffGroups from "../components/StaffGroups";
import Message from "../components/Message";
import AccountInfo from "../components/AccountInfo";
import { setselectedcategory, enterlist, resetstore, menuassign, setmenus } from '../modules/menustore';
import { resetuser } from '../modules/userstore';
import { resetenv } from '../modules/environstore';
import { isEmpty, DeepCopy, isEnabled, replaceall, continueSession, customTarget } from '../modules/appLibrary';
import { resetform, setmenuinfo } from '../modules/formstore';
import { persistor } from '../store';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import { Container, Draggable } from "react-smooth-dnd";
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import Checkbox from '@mui/material/Checkbox';
import Chip from '@mui/material/Chip';
import Menu from '@mui/material/Menu';
import Badge from '@mui/material/Badge';
import { confmsg } from '../modules/msgboxstore';
import '../css/Menu.css'
import Dashboard from './Dashboard';

/*----------------------------------------------------------------------
 * メインメニュ
 * show: true:open 
 * isTop: true:Singin false:close
 * doClose : close call back
 -----------------------------------------------------------------------*/
export default function MainMenu(props) {

    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const user = useSelector(state => state.user);
    const menudata = useSelector(state => state.menu);
    const loginkey = useSelector(state => state.user.loginkey);
    const version = useSelector(state => state.user.version);
    const corpkey = useSelector(state => state.user.corpkey);
    const CORPKEY_TSI = "tsi";  //TSI固有設定判定用
    const corpname = useSelector(state => state.user.corpname);
    const debug = useSelector(state => state.user.debug);
    const category = useSelector(state => state.menu.category);
    const OP_NORMAL = 0;    //カテゴリ動作区分：メニュー展開
    const OP_TITLE = 1;     //カテゴリ動作区分：タイトル（表示のみ）
    const OP_DIRECT = 2;    //カテゴリ動作区分：画面直接遷移
    const menudefs = useSelector(state => state.menu.menudefs); //既定メニュ
    const menus = useSelector(state => state.menu.menus);       //個人メニュまたは既定メニュ
    const menulist1 = useSelector(state => state.menu.menulist1);
    const menulist2 = useSelector(state => state.menu.menulist2);
    const menulist3 = useSelector(state => state.menu.menulist3);
    const original = useSelector(state => state.menu.original); //プライベートメニュ
    const menucolors = useSelector(state => state.menu.menucolors);
    const selectedcategory = useSelector(state => state.menu.selectedcategory);
    const dashboard = useSelector(state => state.menu.dashboard);
    const modify = useSelector(state => state.form.modify);
    const status = useSelector(state => state.form.status);
    const [open, setOpen] = useState(false);
    const [groupopen, setgroupOpen] = useState(false);
    const [messageopen, setmessageOpen] = useState(false);
    const [accountopen, setaccountOpen] = useState(false);
    const [dashboardopen, setdashboardOpen] = useState(false);
    const [copyhide, setcopyhide] = useState(false);
    const [menutitle, setmenutitle] = useState("My MENU");
    const [trashshow, settrashshow] = useState(false);
    const [wapperheight, setwapperheight] = useState(300);
    const [trashheight, settrashheight] = useState(300);
    const [addcategory, setaddcategory] = useState("");
    const [addmenulist, setaddmenulist] = useState([]);
    const [paletteshow, setpaletteshow] = useState(false);
    const [unread, setunread] = useState(0);
    const [newwidth, setnewwidth] = useState('80%')
    const [state, setState] = React.useState({
        delete: false,
        move: false
    });
    const menuRef = useRef();
    const targetRef = useRef();
    const notifyRef = useRef();

    useEffect(() => {
        setOpen(props.show)
        notifyRef.current = false;
        if (props.show) {
            setnewwidth('80%')
            //未読通知取得
            GetUnReadCount();
        }
    }, [props.show])

    useEffect(() => {
        if (props.show && !messageopen) {
            //未読通知取得
            GetUnReadCount();
        }
    }, [messageopen])

    useEffect(() => {
        if (dashboard && props.isTop) {
            setdashboardOpen(true);
        }
    }, [dashboard])

    let resizeWindow = () => {
        let h = window.innerHeight - 100;
        settrashheight(h);
        setwapperheight(h);
    };
    useEffect(() => {
        window.addEventListener("resize", resizeWindow);
        return () => window.removeEventListener("resize", resizeWindow);
    })

    useEffect(() => {
        resizeWindow();
        if (trashshow) {
            createaddmenulist();
            setaddcategory(selectedcategory);
        }
    }, [trashshow]);

    useEffect(() => {
        if (trashshow && addcategory !== "") {
            createaddmenulist();
        }
    }, [addcategory, selectedcategory, menus]);

    function createaddmenulist() {
        let addlist = menudefs.filter(e => e.category === addcategory);
        let orglist = original.filter(e => e.category === addcategory);
        if (!isEmpty(orglist)) {
            addlist = [...addlist, ...orglist];
        }
        let menulist = menus.filter(e => e.category === selectedcategory);
        let newlist = [];
        for (let i = 0; i < addlist.length; i++) {
            let result = menulist.find(e => e.app === addlist[i].app && e.subkey === addlist[i].subkey);
            if (isEmpty(result)) {
                let data = JSON.parse(JSON.stringify(addlist[i]));
                data['add'] = true;
                newlist.push(data);
            }
        }
        setaddmenulist(newlist);
    }


    const [anchorEl, setAnchorEl] = useState(null);
    const cmenuopen = Boolean(anchorEl);
    const ContextMenu = (event,menu) => {
        event.preventDefault();
        targetRef.current = menu;
        setAnchorEl(event.currentTarget);
        setcopyhide(!isEmpty(menu.subkey));

    //    if (state.delete || state.move) {
    //        targetRef.current = menu;
    //        setAnchorEl(event.currentTarget);
    //    } else {
    //        if (!isEmpty(menu.subkey)) {
    //            targetRef.current = menu;
    //            setAnchorEl(event.currentTarget);
    //        }
    //        setcopyhide(!isEmpty(menu.subkey));
    //    }
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    //未読数取得
    function GetUnReadCount() {
        notifyRef.current = true;
        props.fnc.current.postaxios('menu/GetUnReadCount', null,
            {
                onSuccess: function (data) {
                    setunread(Number(data.request));
                    if (!isEmpty(props.fnc.current))props.fnc.current.wait(false);
                },
            }
        )
    }

    //指定されたカテゴリの操作区分を取得する
    function getCategoryOperation(categoryCode) {
        if (categoryCode === "My MENU") return OP_NORMAL;
        const row = category.find(e => e[0] === categoryCode);
        if (isEmpty(row)) return OP_NORMAL;
        const op = Number(row[4] ?? OP_NORMAL);
        return Number.isNaN(op) ? OP_NORMAL : op;
    }

    //画面直接起動カテゴリからメニュー項目を取得する
    function getDirectLaunchMenu(categoryCode) {
        let list = menus.filter(e => e.category === categoryCode);
        if (isEmpty(list)) {
            list = menudefs.filter(e => e.category === categoryCode);
        }
        if (isEmpty(list)) return null;

        list = DeepCopy(list).sort(function (a, b) {
            if (a.column < b.column) return -1;
            if (a.column > b.column) return 1;
            if (a.index < b.index) return -1;
            if (a.index > b.index) return 1;
            return 0;
        });

        return list[0];
    }

    function SelectCategory(e){
        let name = e.currentTarget.getAttribute('data-name');

        const op = getCategoryOperation(name);

        if (op === OP_DIRECT) {
            //画面直接遷移
            const target = getDirectLaunchMenu(name);
            if (!isEmpty(target)) {
                setmenutitle(name);
                SelectMenu(target, e);
            }
            return;
        }

        //通常カテゴリ
        setmenutitle(name);
        dispatch(setselectedcategory(name));
    }
    function SelectMenu(menu,e) {
        if (state.delete || state.move) {
            if (paletteshow) {
                let selectcol = checked[0];
                if (selectcol === "") return;
                let color = menucolors.find(e => e.name === selectcol);
                if (!isEmpty(color)) {
                    let newmenu = DeepCopy(menus);
                    let m = newmenu.find(e => e.category === selectedcategory && e.controller === menu.controller && e.subkey === menu.subkey);
                    if (!isEmpty(m)) {
                        m["backcolor"] = color.backcolor;
                        m["forecolor"] = color.forecolor;
                        dispatch(menuassign(newmenu));
                    }
                }
            }
            return;
        }
        var ctrl = (e.ctrlKey && !e.metaKey) || (!e.ctrlKey && e.metaKey);
        if (menu.extarnal === 0) {
            //コントローラ
            if (status !== "VIEW" && modify && !ctrl) {
                dispatch(confmsg({ msg: "編集中の内容があります。メニュを起動してよろしいですか?", cmd: () => SendMenu(ctrl), cancel: () => props.doClose() }));
                return;
            }
            if (!ctrl) {
                props.doClose();
            }
            SendMenu(ctrl);
        } else if(menu.extarnal === 2){
            //ファイルダウンロード
            //let menu = menus.find(e => e.category === selectedcategory && e.controller === controller && e.subkey === subkey);
            //props.fnc.current.postaxios('menu/GetURLParam', {code:menu.app},
            props.fnc.current.postaxios('menu/GetURLParam', { code: menu.app },
                {
                    onSuccess: function (data) {
                        if (isEmpty(data.returnData['param'])) {
                            props.fnc.current.warnmsg("メニュ情報が取得できませんでした");
                            return;
                        }
                        let params = {};
                        let list = data.returnData['param'].split(',');
                        for (let i = 0; i < list.length; i++) {
                            let p = list[i].split('=');
                            params[p[0]] =p[1];
                        }
                        props.fnc.current.filedownload(data.returnData['url'], params);
                    },
                }
            )
        } else {
            //外部URL
            //let menu = menus.find(e => e.category === selectedcategory && e.controller === controller && e.subkey === subkey);
            //props.fnc.current.postaxios('menu/GetURLParam', { code: menu.app },
            props.fnc.current.postaxios('menu/GetURLParam', { code: menu.app },
                {
                    onSuccess: function (data) {
                        props.fnc.current.wait(false);
                        window.open(data.returnData['param'], '_blank');
                    },
                }
            )
        }
        function SendMenu(ctrl) {
            let url = replaceall(location.pathname, '/', '') + location.search;
            let newurl = appurl(menu.controller, menu.subkey);
            if (ctrl) { //別タブ起動
                let key = continueSession(user, menudata,menu);
                if (newurl.indexOf('?') === -1) {
                    newurl += "?key=" + key;
                } else {
                    newurl += "&key=" + key;
                }
                window.open('/' + newurl);
            } else {
                if (url === newurl) {
                    props.doClose();
                    return;
                }
                dispatch(resetform());
                dispatch(setmenuinfo(menu));
                history.push('/' + newurl);
            }
        }
    }
    function ShowReleaseNote() {
        window.open('/ReleaseNote?id=' + corpkey);
    }

    function appurl(controller, subkey) {
        if (isEmpty(subkey)) {
            return controller;
        }
        if (controller.indexOf("?") !== -1) {
            return controller + "&subkey=" + subkey;
        } else {
            return controller + "?subkey=" + subkey;
        }
    }
    const [checked, setChecked] = React.useState(['']);

    const handleToggle = (value) => () => {
        const newChecked = [];
        newChecked.push(value);
        setChecked(newChecked);
    };

    function onMouseEnter(e) {
        if (state.move) return;
        let name = e.currentTarget.getAttribute('data-name');
        setmenutitle(name) ;
        dispatch(enterlist(name));
    }
    function onMouseLeave (e){
        if (state.move) return;
        setmenutitle( selectedcategory);
        dispatch(enterlist(selectedcategory));
    }
    function logout() {
        setunread(0);
        dispatch(resetuser());
        dispatch(resetstore());
        dispatch(resetenv());
        persistor.purge();
        history.push('/')
    };
    function onDebug(mode) {
        props.fnc.current.filedownload("menu/DebugFileDownload", { mode: mode, corpkey: corpname});
    }

    function doClose() {
        if (props.isTop && !isEmpty(loginkey)) {
            logout();
            return;
        }
        setunread(0);
        if (state.delete) {
            if (JSON.stringify(menuRef.current) !== JSON.stringify(menus)) {
                props.fnc.current.confmsg(["レイアウトが保存されていません。", "編集内容は無効になりますがよろしいですか？"], () => cancel());
            } else {
                apply();
            }
            function cancel() {
                dispatch(menuassign(menuRef.current));
                apply();
            }
            function apply() {
                setState({
                    delete: false,
                    move: false,
                });
                settrashshow(false);
                setpaletteshow(false);
                props.doClose();
            }
        } else {
            props.doClose();
        }
    }

    function ResetMenu() {
        props.fnc.current.confmsg("MyMenu以外を既定のメニュレイアウトに戻します。よろしいですか？", () => Action());
        function Action() {
            let newmenu = DeepCopy(menudefs);
            newmenu = [...newmenu, ...menus.filter(e => e.category === "My MENU")];
            dispatch(menuassign(newmenu));
        }
    }

    function EditStart(start) {
        if (start) {
            menuRef.current = DeepCopy(menus);
            setnewwidth('100%')
            apply();
        } else {
            if (JSON.stringify(menuRef.current) !== JSON.stringify(menus)) {
                props.fnc.current.confmsg(["レイアウトが保存されていません。","編集内容は無効になりますがよろしいですか？"], () => cancel());
            } else {
                apply();
            }
            setnewwidth('80%')
        }
        function cancel() {
            dispatch(menuassign(menuRef.current));
            apply();
        }
        function apply() {
            setState({
                delete: start,
                move: start,
            });
            if (!start) {
                settrashshow(false);
                setpaletteshow(false);
            }
        }
    }
    function SaveMenu() {
        props.fnc.current.confmsg("現在のメニュ構成を保存します。よろしいですか？", ()=>Save());
        function Save() {
            const param = {
                "menus": menus
            }
            props.fnc.current.postaxios('menu/SaveMenu', param,
                {
                    onSuccess: function (data) {
                        dispatch(menuassign(menus));
                        setState({
                            delete: false,
                            move: false,
                        });
                        setnewwidth('80%')
                        settrashshow(false);
                        setpaletteshow(false);
                        props.fnc.current.success();
                        props.fnc.current.wait();
                    },
                    errmsg: "保存に失敗しました"
                }
            )
        }
    }


    function changeName() {
        handleClose();
        if (isEmpty(targetRef.current)) return;
        props.fnc.current.formdialogopen(
            {
                title: "メニュタイトル変更", dialogtype: 0,
                inputname:"メニュタイトル",
                contents: "現メニュタイトル：" + targetRef.current.name,
                placeholder: "新たなメニュタイトル",
                onApply: (param) => Action(param)
            });
        function Action(title) {
            let result = menudefs.find(e => e.name === title);
            if (!isEmpty(result)) {
                props.fnc.current.warnmsg("このメニュタイトルは存在しています。");
                return;
            }
            var menu = targetRef.current;
            props.fnc.current.postaxios('menu/ChangeMenuTitle',
                {
                    controller: menu.controller, subkey: menu.subkey,
                    code: title
                },
                {
                    onSuccess: function (data) {
                        props.fnc.current.formdialogclose();
                        let newmenu = DeepCopy(menus);
                        let app = newmenu.find(e => e.controller === menu.controller && e.subkey === menu.subkey);
                        app.name = title;
                        dispatch(menuassign(newmenu));
                        createaddmenulist();
                        props.fnc.current.success();
                        props.fnc.current.wait(false);
                    },
                }
            )
        }
    }

    function RemoveMenu(menu) {
        let newmenu = menus.filter(p => p !== menu);
        dispatch(menuassign(newmenu));
    }
    function menuDelete() {
        if (isEmpty(targetRef.current)) return;
        handleClose();
        if (state.move) {
            props.fnc.current.confmsg(["'" + targetRef.current.name + "'メニュをパネルから除外しますよろしいですか？", "メニュ追加で復元することができます。"], () => RemoveMenu(targetRef.current));
        } else {
            props.fnc.current.confmsg(["'" + targetRef.current.name + "'メニュを完全削除します。メニュの復帰はできませんがよろしいですか？", "除外のみ行う場合は「編集開始」後行ってください。"], () => DeltePrivateMenu(targetRef.current));
        }
        function DeltePrivateMenu(menu) {
           props.fnc.current.postaxios('menu/DeletePrivateMenu',
                {
                    "controller": menu.controller, subkey: menu.subkey
                },
                {
                    onSuccess: function (data) {
                        let newmenu = menus.filter(p => p.controller !== menu.controller || p.subkey !== menu.subkey);
                        dispatch(menuassign(newmenu));
                        if (state.move) {
                            createaddmenulist();
                        }
                        props.fnc.current.success();
                        props.fnc.current.wait(false);
                        //起動中メニュの場合Topへ
                        if (props.controller === menu.controller && props.subkey === menu.subkey) {
                            setunread(0);
                            history.push('/Top#menu');
                        }
                    },
                }
            )
        }
    }
    
    function menuCopy() {
        if (isEmpty(targetRef.current)) return;
        if (targetRef.current.extarnal) {
            props.fnc.current.warnmsg("外部メニュです。複製できません。");
            return;
        }
        var controller = targetRef.current.controller;
        var subkey = targetRef.current.subkey;
        handleClose();
        props.fnc.current.formdialogopen({
            title: "メニュの複製", inputname: "メニュタイトル", dialogtype: 0,
            placeholder: "メニュタイトルを入力してください",
            defaultvalue: '',
            contents: "'" + targetRef.current.name + "'メニュを複製します。",
            contents2: "※起動時設定が「前回レイアウトを表示」の場合は既定レイアウトで表示されます。", 
            customcontents: 2,
            onApply: (e) => Save(e)
        });
        function Save(e) {
            var title = e.name;
            let result = menus.find(p => p.name === title);
            if (!isEmpty(result)) {
                props.fnc.current.warnmsg("このメニュタイトルは登録済です");
                return;
            }

            props.fnc.current.postaxios('menu/CopyMenu',
                {
                    "controller": controller, subkey: subkey, "code": title, "type": selectedcategory, "status":e.check
                },
                {
                    onSuccess: function (data) {
                        let menu = menus.find(p => p.controller === controller && p.subkey === subkey && p.category === selectedcategory);
                        if (!isEmpty(menu)) {
                            let newapp = DeepCopy(menu);
                            newapp.subkey = data.request;
                            newapp.name = title;
                            let newmenu = [...menus, ...[newapp]];
                            dispatch(menuassign(newmenu));
                        }
                        props.fnc.current.formdialogclose();
                        props.fnc.current.success();
                        props.fnc.current.wait(false);
                    },
                }
            )
        }
    }
    function onMenuDrop(columnidx, dropResult) {
        if (columnidx === 4) return;
        if (dropResult.addedIndex === null) return;

        let menulist = menus.filter(p => p !== dropResult.payload);
        if (!isEmpty(dropResult.payload)) {
            if (isEnabled(dropResult.payload.add)) {
                menulist = menus;
            }
        }
        var newmenu = menulist.filter(p => p.category !== selectedcategory || p.column !== columnidx);
        let columns = menulist.filter(p => p.category === selectedcategory && p.column === columnidx);
        columns.sort(function (a, b) {
            if (a.index < b.index) return -1;
            if (a.index > b.index) return 1;
            return 0;
        });
        let adddata = JSON.parse(JSON.stringify(dropResult.payload));
        adddata.category = selectedcategory;
        delete adddata['add'];

        let seqno = 0;
        if (dropResult.addedIndex === 0) {
            adddata.column = columnidx;
            adddata.index = seqno;
            newmenu.push(adddata);
            seqno++;
        }
        for (let i = 0; i < columns.length; i++) {
            if (seqno === dropResult.addedIndex) {
                adddata.column = columnidx;
                adddata.index = seqno;
                newmenu.push(adddata);
                seqno++;
            }
            let data = JSON.parse(JSON.stringify(columns[i]));
            data.index = seqno;
            newmenu.push(data);
            seqno++;
        }
        if (seqno === dropResult.addedIndex) {
            adddata.column = columnidx;
            adddata.index = seqno;
            newmenu.push(adddata);
            seqno++;
        }

        dispatch(menuassign(newmenu));
    }
    function getMenuPayload(columnidx, index) {
        if (columnidx === 4) {
            return addmenulist[index];
        } else {
            let menulist = menus.filter(p => p.category === selectedcategory && p.column === columnidx);
            menulist.sort(function (a, b) {
                if (a.index < b.index) return -1;
                if (a.index > b.index) return 1;
                return 0;
            });
            return menulist[index];
        }
    }
    const categoryNodes = category.map((category) => {
        const op = getCategoryOperation(category[0]);
        const className = `${selectedcategory === category[0] ? 'menupanelcat menupanelnavselect' : 'menupanelcat'}${op === OP_TITLE ? ' menupanelcattitle' : ''}`;

        return (
            <li key={category[0]} ><div className={className} data-name={category[0]}
                onClick={op === OP_TITLE ? undefined : SelectCategory}
                onMouseEnter={op === OP_NORMAL ? onMouseEnter : undefined}
                onMouseLeave={op === OP_NORMAL ? onMouseLeave : undefined}
            >{customTarget(corpkey, CORPKEY_TSI) ? (
                //TSI固有の実装（カテゴリ名）
                <><span className="material-icons">{category[5]}</span>{category[1]}</>
            ) : (
                <>{category[1]}<div className="menupanelalph">- {category[0]}</div></>
            )}</div></li>
        );
    });

    function SelectDashboard() {
        //暫定：マイメニューの呼び出しとしておく
        setmenutitle("My MENU");
        dispatch(setselectedcategory("My MENU"));
    }

    function SelectFixedChat() {
        //暫定：チャット機能は未実装なので空振り
        return;
    }

     return (
         <Drawer anchor={props.isTop ? "top" : "right"} open={open} onClose={doClose}
             PaperProps={{ style: { width: props.isTop ? "100%" : newwidth } }} id="menupanel">
            <Dashboard
                show={dashboardopen}
                fnc={props.fnc}
                doClose={() => setdashboardOpen(false)}
            /> 
             <Message
                 show={messageopen}
                 fnc={props.fnc}
                 doClose={() => setmessageOpen(false)}
             />
             <StaffGroups
                 show={groupopen}
                 fnc={props.fnc}
                 doClose={() => setgroupOpen(false)}
             />
             <AccountInfo
                 show={accountopen}
                 fnc={props.fnc}
                 doClose={() => setaccountOpen(false)}
             />
             <div style={{ display: 'flex' }}>
                {/*カテゴリ*/}
                 <div id="menupanel_left" style={{ width: 300, height: '100vh', backgroundColor: '#0D221E', paddingLeft: 30 }}>
                     {/*{!props.isTop ? null :*/}
                         <div id="menupanelclose" style={{ position: 'absolute', top: 0, left: 0 }}>
                             <IconButton onClick={doClose} title={props.isTop ? "Signinへ" : "MENUを閉じる"}>
                                 {props.isTop ?
                                    <i className="material-icons light">arrow_back</i>
                                     :
                                    <i className="material-icons light">close</i>
                                 }
                             </IconButton>
                         </div>
                     {/*}*/}
                     {!dashboard?null:
                         <div style={{ position: 'absolute', top: 0, left: 110 }}>
                             <IconButton onClick={() => setdashboardOpen(true)} title="ダッシュボード">
                                 <i className="material-icons light">dashboard</i>
                             </IconButton>
                         </div>
                     }
                     <div style={{ position: 'absolute', top: 0, left: 160 }}>
                         <IconButton onClick={() => setmessageOpen(true)} title="通知">
                             <Badge color="secondary" badgeContent={unread}
                                    anchorOrigin={{
                                     vertical: 'bottom',
                                     horizontal: 'right',
                                 }} >
                                 <i className="material-icons light">notifications</i>
                             </Badge>
                         </IconButton>
                         <IconButton onClick={() => setgroupOpen(true)} title="担当者グループ設定">
                             <i className="material-icons light">groups</i>
                         </IconButton>
                         <IconButton onClick={() => setaccountOpen(true)} title="アカウント情報">
                             <i className="material-icons light">manage_accounts</i>
                         </IconButton>
                     </div>

                     <div id="menupanel_main">
                        {customTarget(corpkey, CORPKEY_TSI) ? (
                            //TSI固有の実装（カテゴリ上部の表示）
                            <>
                                <div className="logofont productname">CoreApparel-PS</div>
                                <div className="logofont projectname">Projected by {corpname}</div>
                            </>
                        ) : (
                            <>
                                <div className="logofont" style={{ marginTop: 50, color: '#999999', fontSize: 30 }}>KKAP Lite</div>
                                <div className="logofont" style={{ color: '#999999', fontSize: 15 }}>version {version}
                                    <span style={{marginLeft:100}} >
                                        <IconButton onClick={ShowReleaseNote} title="リリースノート">
                                            <i className="material-icons light" style={{ fontSize: 18, color: '#999999' }}>article</i>
                                        </IconButton>
                                    </span>
                                </div>
                            <div className="logofont" style={{ marginTop: 10, color: '#999999', fontSize: 20 }}>{corpname}</div>
                            </>
                        )}

                        {/*メニュカテゴリ*/}
                        <div style={{ marginTop: 50 }}>
                            <ul id="menupanelnav">
                                {customTarget(corpkey, CORPKEY_TSI) ? (
                                    <>
                                        <li>
                                            <div className="menupanelcat" onClick={SelectDashboard}>
                                                <span className="material-icons">dashboard</span>ダッシュボード
                                            </div>
                                        </li>
                                        <li>
                                             <div className="menupanelcat" onClick={SelectFixedChat}>
                                                 <span className="material-icons">chat</span>チャット
                                            </div>
                                        </li>
                                    </>
                                ) : (
                                    <>
                                        <li><div className={`${selectedcategory === "My MENU" ? 'menupanelcat menupanelnavselect' : 'menupanelcat'}`} data-name="My MENU"
                                            onClick={SelectCategory}
                                            onMouseEnter={onMouseEnter}
                                            onMouseLeave={onMouseLeave}
                                        >★<div className="menupanelalph">- My MENU</div></div></li>
                                    </>
                                )}
                                {categoryNodes}
                            </ul>
                        </div>
                    </div>
                    <div style={{ position: 'absolute', bottom: 10, left: 10 }}>
                        <div className="pointer" title="ログアウト" onClick={logout}>
                            <img className="imagehover" src={imgquit} alt=""/>
                        </div>
                     </div>
                    {customTarget(corpkey, CORPKEY_TSI) ? (
                        //TSI固有の実装（バージョンとリリースノート）
                        <div className="logofont" style={{ position: 'absolute', bottom: 14, left: 80, width:200, textAlign: 'right', color: '#999999', fontSize: 14 }}>
                            <div onClick={ShowReleaseNote}>
                                KKAP Lite v{version}
                            </div>
                        </div>
                    ):null}
                    {debug?
                         <div style={{ position: 'absolute', bottom: 20, left: 200 }}>
                             <span className="logofont" style={{ color: '#fff', fontSize: 15, cursor:"pointer" }} onClick={()=>onDebug("SQL")}>
                                 SQL
                             </span>
                             <span className="logofont" style={{ marginLeft: 20, color: '#fff', fontSize: 15, cursor: "pointer" }} onClick={() => onDebug("LOG")}>
                                 LOG
                             </span>
                         </div>
                         :null
                        }
                </div>
                 {/*メニュ*/}
                 <div className="menupanelcontents" id="menupanel_center" style={{ position: 'relative' }}>
                     <div style={{ padding:'30px 0 0 30px' }}>
                        <h2>
                            <span id="menupanelcattitle" className="categoryfont" style={{ fontSize: 20, color: '#999999' }}>{menutitle}</span>
                            <div style={{ position: 'absolute', top:10, right: 60 }}>
                            {state.delete ?
                                <React.Fragment>
                                    <span className="staplebtn" title="現在のメニュレイアウトを保存します" onClick={SaveMenu}>保存</span>
                                    <span style={{ marginLeft:5 }} className="staplebtn" onClick={() => EditStart(false)}>中止</span>
                                </React.Fragment>
                                :
                                <span className="staplebtn" title="メニュレイアウトの編集を可能にします" onClick={()=>EditStart(true)}>編集開始</span>
                            }
                            </div>
                            {/* {!props.isTop ?*/}
                            {/*     <div id="menupanelclose" style={{ position: 'absolute', top: 0, right: 0 }}>*/}
                            {/*         <IconButton onClick={doClose} title={"MENUを閉じる"}>*/}
                            {/*             <i className="material-icons">close</i>*/}
                            {/*         </IconButton>*/}
                            {/*     </div>*/}
                            {/*: null}*/}
                             {/*ツール*/}
                             {(trashshow || paletteshow || !state.delete)?null:
                             <div style={{ position: 'absolute', top: 50, right: 5 }}>
                                 <div>
                                     <IconButton onClick={() => settrashshow(true)} title="メニュ追加">
                                     <Icon style={{ fontSize: 30 }}>add_box</Icon>
                                     </IconButton>
                                </div>
                                 <div>
                                     <IconButton onClick={() => setpaletteshow(true)} title="カラー設定">
                                     <Icon style={{ fontSize: 30 }}>color_lens</Icon>
                                 </IconButton>
                                 </div>
                                 <div>
                                 <IconButton onClick={ResetMenu} title="既定メニュに戻す">
                                     <Icon style={{ fontSize: 30 }}>refresh</Icon>
                                 </IconButton>
                                 </div>
                                 </div>
                             }
                        </h2>
                        <div className="menupanelwapper" style={{ height: wapperheight }}>
                            {/*Menu 左*/}
                            <div className="menupanelbox" id="menupanelbox1" >
                            <Container
                                groupName="col"
                                dragHandleSelector=".dragpanelHandleSelector"
                                onDrop={e => onMenuDrop(0, e)}
                                        getChildPayload={index =>
                                            getMenuPayload(0, index)
                                        }
                                    >
                                {menulist1.map(menu => {
                                return (
                                    <Draggable key={menu.controller + '_' + menu.subkey}>
                                        <div className="menupanelitem" title={menu.controller} 
                                            style={{ backgroundColor: menu.backcolor, color: menu.forecolor, position: 'relative' }}
                                            onContextMenu={(e)=>ContextMenu(e,menu)}
                                            onClick={(e) => SelectMenu(menu,e)}>
                                            {menu.name}
                                            <div style={{ position: 'absolute', top: 10, right: 10 }}>
                                                {menu.subkey !== '' && !menu.share ?
                                                    <IconButton size="small">
                                                        <Icon style={{ fontSize: 16 }}>person_pin</Icon>
                                                    </IconButton>
                                                    : null}
                                                {menu.subkey !== '' && menu.share ?
                                                    <IconButton size="small">
                                                        <Icon color="primary" style={{ fontSize: 16 }}>person_pin</Icon>
                                                    </IconButton>
                                                    : null}
                                                {state.move ?
                                                <IconButton size="small" style={{ cursor: 'move' }} className="dragpanelHandleSelector">
                                                    <Icon style={{ fontSize: 16 }}>drag_indicator</Icon>
                                                </IconButton>
                                                : null}
                                            </div>
                                        </div>
                                    </Draggable>
                                );
                            })}
                            </Container>
                        </div>
                        {/*Menu 中央*/}
                        <div className="menupanelbox" id="menupanelbox2">
                            <Container
                                groupName="col"
                                dragHandleSelector=".dragpanelHandleSelector"
                                onDrop={e => onMenuDrop(1, e)}
                                getChildPayload={index =>
                                    getMenuPayload(1, index)
                                }
                            >
                                {menulist2.map(menu => {
                                    return (
                                        <Draggable key={menu.controller + '_' + menu.subkey}>
                                            <div className="menupanelitem" title={menu.controller}
                                                style={{ backgroundColor: menu.backcolor, color: menu.forecolor, position: 'relative' }}
                                                onContextMenu={(e) => ContextMenu(e, menu)}
                                                onClick={(e) => SelectMenu(menu,e)}>
                                                {menu.name}
                                                <div style={{ position: 'absolute', top: 10, right: 10 }}>
                                                    {menu.subkey !== '' && !menu.share ?
                                                        <IconButton size="small">
                                                            <Icon style={{ fontSize: 16 }}>person_pin</Icon>
                                                        </IconButton>
                                                        : null}
                                                    {menu.subkey !== '' && menu.share ?
                                                        <IconButton size="small">
                                                            <Icon color="primary" style={{ fontSize: 16 }}>person_pin</Icon>
                                                        </IconButton>
                                                        : null}
                                                    {state.move ?
                                                        <IconButton size="small" style={{ cursor: 'move' }} className="dragpanelHandleSelector">
                                                            <Icon style={{ fontSize: 16 }}>drag_indicator</Icon>
                                                        </IconButton>
                                                        : null}
                                                </div>
                                            </div>
                                        </Draggable>
                                    );
                                })}
                            </Container>
                        </div>
                        {/*Menu 右*/}
                        <div className="menupanelbox" id="menupanelbox3">
                            <Container
                                groupName="col"
                                dragHandleSelector=".dragpanelHandleSelector"
                                onDrop={e => onMenuDrop(2, e)}
                                getChildPayload={index =>
                                    getMenuPayload(2, index)
                                }
                            >
                                {menulist3.map(menu => {
                                    return (
                                        <Draggable key={menu.controller + '_' + menu.subkey}>
                                            <div className="menupanelitem" title={menu.controller}
                                                style={{ backgroundColor: menu.backcolor, color: menu.forecolor, position: 'relative' }}
                                                onContextMenu={(e) => ContextMenu(e, menu)}
                                                onClick={(e) => SelectMenu(menu,e)}>
                                                {menu.name}
                                                <div style={{ position: 'absolute', top: 10, right: 10 }}>
                                                    {menu.subkey !== '' && !menu.share ?
                                                        <IconButton size="small">
                                                            <Icon style={{ fontSize: 16 }}>person_pin</Icon>
                                                        </IconButton>
                                                        : null}
                                                    {menu.subkey !== '' && menu.share ?
                                                        <IconButton size="small">
                                                            <Icon color="primary" style={{ fontSize: 16 }}>person_pin</Icon>
                                                        </IconButton>
                                                        : null}
                                                    {state.move ?
                                                        <IconButton size="small" style={{ cursor: 'move' }} className="dragpanelHandleSelector">
                                                            <Icon style={{ fontSize: 16 }}>drag_indicator</Icon>
                                                        </IconButton>
                                                        : null}
                                                </div>
                                            </div>
                                        </Draggable>
                                    );
                                })}
                            </Container>
                            </div>
                        </div>
                    </div>
                 </div>
                 {/*addmenu*/}
                 <div id="menupanelhidemenu" style={{ display: trashshow ? '' : 'none' }}>
                     {/*<div style={{ position: 'fixed', top: 10, right: 10 }}>*/}
                     {/*    <IconButton onClick={() => settrashshow(false)} title="閉じる">*/}
                     {/*        <Icon>close</Icon>*/}
                     {/*    </IconButton>*/}
                     {/*</div>*/}
                     <Select
                         style={{ width: 150, marginLeft: 5, marginBottom: 5 }}
                         value={addcategory}
                         onChange={(params) => setaddcategory(params.target.value)}
                     >
                         {category.filter(category => getCategoryOperation(category[0]) === OP_NORMAL).map(category => (
                             <MenuItem key={category[0]} value={category[0]}>{category[1]}</MenuItem>
                         ))}
                         <MenuItem key={'share'} value={'share'}>共有</MenuItem>
                     </Select>
                     <div style={{ height: trashheight, overflow: 'auto' }}>
                         <div>
                             <Container
                                 groupName="col"
                                 dragHandleSelector=".dragpanelHandleSelector"
                                 onDrop={e => onMenuDrop(4, e)}
                                 getChildPayload={index =>
                                     getMenuPayload(4, index)
                                 }
                             >
                                 {addmenulist.map(menu => {
                                     return (
                                         <Draggable key={menu.controller + '_' + menu.subkey}>
                                             <div className="hidepanelitem" title={menu.controller} style={{ position: 'relative' }} >
                                                 {state.move ?
                                                     <IconButton size="small" style={{ cursor: 'move' }} className="dragpanelHandleSelector">
                                                         <Icon style={{ fontSize: 10, color:"#fff" }}>drag_indicator</Icon>
                                                     </IconButton>
                                                     : null}
                                                 {menu.name}
                                             </div>
                                         </Draggable>
                                     );
                                 })}


                             </Container>
                         </div>
                     </div>
                 </div>
                 {/*pallet*/}
                 <div id="menupanelhidemenu" style={{ display: paletteshow ? '' : 'none' }}>
                     <div style={{ position: 'fixed', top: 10, right: 10 }}>
                         <IconButton onClick={() => setpaletteshow(false)} title="閉じる">
                             <Icon>close</Icon>
                         </IconButton>
                     </div>
                     <div style={{ height: trashheight, overflowY: 'auto', overflowX:'none', marginTop: 25  }}>
                     <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                         {menucolors.map((color) => {
                             return (
                                 <ListItem
                                     key={color.name}
                                     disablePadding
                                 >
                                     <ListItemButton role={undefined} onClick={handleToggle(color.name)} dense>
                                         <ListItemIcon>
                                             <Checkbox
                                                 edge="start"
                                                 checked={checked.indexOf(color.name) !== -1}
                                                 tabIndex={-1}
                                                 disableRipple
                                             />
                                         </ListItemIcon>
                                         <Chip label={color.name}
                                             style={{ backgroundColor: color.backcolor, color: color.forecolor, width:100 }}
                                         />
                                     </ListItemButton>
                                 </ListItem>
                             );
                         })}
                     </List>
                 </div>
                 </div>
            </div>
             <Menu
                 anchorEl={anchorEl}
                 open={cmenuopen}
                 onClose={handleClose}
                 anchorOrigin={{
                     vertical: 'top',
                     horizontal: 'right',
                 }}
                 transformOrigin={{
                     vertical: 'top',
                     horizontal: 'right',
                 }}
             >
                 {!state.move ?
                         <MenuItem onClick={menuCopy}>複製</MenuItem>
                     :
                     <MenuItem onClick={menuDelete}>除外</MenuItem>
                 }
                 {!state.move && copyhide ?
                     <React.Fragment>
                         <MenuItem onClick={changeName}>メニュタイトル変更</MenuItem>
                         <MenuItem onClick={menuDelete}>完全削除</MenuItem>
                     </React.Fragment>
                     : null
                 }
             </Menu>
        </Drawer>
    )
}
